<template>
	<div class="ReSearchScndObjSmall" v-if="objData">
		<!--pre>{{objData}}</pre-->
		<card class="objectCard" @click="OpenObject(objData.id)">
			<div class="objectContent">
				<div class="leftPart">
					<div class="objectPhoto">
						<div class="objectImg">
							<img v-if="objData.mainPhoto !=''" :src="`${objData.mainPhoto}`" onerror="this.src='/img/flatsDefault.svg'; this.onerror=''" alt="" @click="OpenObject(objData.id)"> 
							<img v-else src="/img/flatsDefault.svg" alt="" @click="OpenObject(objData.id)"> 
						</div>
						<div class="d-flex justify-content-start mt-2 ">
							<div class="w-100" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined'">
								<base-button v-if="parseInt(objData.inPresentation)==0" type="primary" simple class="w-100"  @click="AddToPres()"><i class="tim-icons icon-book-bookmark mr-2"></i>Добавить к презентациям</base-button>
								<base-button  v-else type="success" simple class="w-100" @click="GoToPres()"><i class="tim-icons icon-book-bookmark mr-2"></i>В презентациях</base-button>
							</div>

						</div>

						<div class="row align-items-center mx-0 mt-1">
							<p class="mb-0" v-if="typeof objData.creationDate !='undefined' || objData.creationDate!='' || objData.creationDate!='0000-00-00 00:00:00'">Добавлено {{$GVO.convertDateTimeFromMysql(objData['creationDate'])}}</p>
							<p class="mb-0" v-if="typeof objData.lastUpdateDate !='undefined' || objData.lastUpdateDate!=''">Обновлено {{$GVO.convertDateTimeFromMysql(objData['lastUpdateDate'])}}</p>
						</div>
						<div class="row align-items-center mx-0 mt-1">
							<span class="badge badge-default mr-2" style="font-size: 14px;">ID {{objData.id}}</span>
						</div>
						<div class="row align-items-center mx-0 mt-1">
							<span class="badge badge-primary mr-2" v-if="objData.source!='' || objData.source!=null">{{objData.source}}</span>
							<span class="badge badge-primary mr-2">{{objData.salesType}}</span>
							<a :href="objData.url" target="_blank" v-if="(objData.url!='' || objData.url!=null) && objData.source!=''">Объект на {{objData.source}}</a>
						</div>
						
					</div>
				</div>
				<div class="rightPart">
					<div class="row">
						<div class="col-lg-6 col-sm-12 mb-4">
							<h4 class="mb-2">{{objData.title}}</h4>
							<h4 class="objectPrice mb-2" v-if="objData.price!=null">{{$GVO.number_format(objData.price,0,'.',' ')}} ₽</h4>
							<p class="mb-2" v-if="objData.area!=null">S общая {{$GVO.number_format(objData.area,0,'.',' ')}} м²</p>
							<div class="metro" >
								<div class="row flex-nowrap ml-0 mr-2 align-items-top" v-if="objData.metroName !='' && objData.metroName!=null">
									<i class="tim-ic ic-metro text-primary mr-1"></i>
									<p>метро {{objData.metroName}}, </p>									
								</div> 								
								<div class="row ml-0 mr-2 align-items-center" v-if="objData.fromSubway !='' && objData.fromSubway!=null && objData.fromSubway !='0.00'">
									<p>{{objData.fromSubway}} км</p>									
								</div> 								
							</div>
							<div class="objectLocation">
								<div class="objectAddress"><p>{{objData.region}}, {{objData.address}}</p></div>
							</div>
						</div>
						
						<div class="col-sm-12 mb-4">
							<h4 class="objectDescr-title mb-2 px-0">Описание</h4>					
							<div class="objectDescr"><p>{{objData.description}}</p></div>
						</div>
						<div class="col-sm-12" v-if="objData.result_name!='' && objData.result_name!=null">
							<div class="callClass px-3">
								<!-- <hr> -->
								<h4 class="objectDescr-title mb-2 px-0">Классификация звонка</h4>					
								<div class="objectDescr"><p class="mb-0">Тип: {{objData.result_name}}</p></div>
								<div class="objectDescr" v-if="objData.result_descr!='' && objData.result_descr!=null" ><p >Примечание: {{objData.result_descr}}</p></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
	</div>
</template>

<script>

	export default {
		name: 'ReSearchScndObjSmall',
		components: {            			
		},
		props: {
			objData: Object,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {
			// OpenComplex(gk_name_tr){
			// 	//const masExcludeParams = ['dSearchType','p','c2p','dSortType','dSortOrder','dnotworkgk'];
			// 	const masExcludeParams = ['p','c2p','AddComplexMinFlatsBig'];
			// 	this.objGetParams = this.$GVO.GetAllGet();
			// 	let strConstGetParams = '';
			// 	let masParams = [];
			// 	if(typeof this.objGetParams.task_id != 'undefined' && typeof this.objGetParams.taskend_id != 'undefined' && typeof this.objGetParams.client_id != 'undefined'){
			// 		strConstGetParams = `?task_id=${this.objGetParams.task_id}&taskend_id=${this.objGetParams.taskend_id}&client_id=${this.objGetParams.client_id}`;
			// 	}
				
			// 	for (const key in this.objGetParams) {
			// 		if (Object.hasOwnProperty.call(this.objGetParams, key)) {
			// 			if(masExcludeParams.indexOf(key) == -1){
			// 				if(key == 'dSearchType'){ 
			// 					masParams.push(key+'=flat_list');
			// 				}else{
			// 					masParams.push(key+'='+this.objGetParams[key]);
			// 				}
			// 			}
			// 		}
			// 	}
			// 	if(masParams.length > 0){
			// 		strConstGetParams = '?'+masParams.join('&');
			// 	}
			// 	//this.$router.push({path: '/data/module/sso/object/complex/'+gk_name_tr+strConstGetParams});
			// 	//console.log('/data/module/sso/object/complex/'+gk_name_tr+strConstGetParams);
			// 	location.href = '/data/module/sso/object/complex/'+gk_name_tr+strConstGetParams;
			// },
			OpenObject(id){
				this.objGetParams = this.$GVO.GetAllGet();
				let strConstGetParams = '';
				//let masParams = [];
				if(typeof this.objGetParams.task_id != 'undefined' && typeof this.objGetParams.taskend_id != 'undefined' && typeof this.objGetParams.client_id != 'undefined'){
					strConstGetParams = `?task_id=${this.objGetParams.task_id}&taskend_id=${this.objGetParams.taskend_id}&client_id=${this.objGetParams.client_id}`;
				}

				location.href = '/data/module/sso/object/second/'+id+strConstGetParams;
			},
			GoToPres(){
				const objGetParams = this.$GVO.GetAllGet();
				//location.href=`/data/module/sso/object/second/?show_pres=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
				location.href=`/data/module/sso/?show_pres=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}&dSearchType=flats`;
			},
			AddToPres(){
				const objGetParams = this.$GVO.GetAllGet();
				if(!this.$GVO.isEmpty(objGetParams)){
					this.$GVO.ApiCall('INSUPD_OBJ_TO_PRES',{
						obj:'presentations',
						flt:{
							client_id:objGetParams.client_id,
							task_id:objGetParams.task_id,
							taskend_id:objGetParams.taskend_id
						},iData:{
							app_id:this.objData.id,
							type: 2
						}
					})
					.then((objApi) => {
						if(objApi.success === true){
							this.objData.inPresentation = 1;
						}
					}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
				}else{
					alert('Нет параметров задачи и клиента');
				}
			},
		},
	}
</script>
<style scoped>
.objectCard {border: 1px solid #9e77f3; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; margin-bottom: 20px;}
.objectPhoto img:hover {cursor: pointer; box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.5); border: 1px solid #01b0e0;}
/*.objectCard:hover {cursor: pointer; box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.5);}*/
.objectCard p {margin-bottom: 8px;}
.objectContent {display: flex;}
.leftPart {display: flex; /*margin-right: 10px; padding-right: 10px;*/}
.rightPart {display: flex; flex-direction: column; padding-left: 15px; width: 100%;}
.objectImg {width: 320px; height: 320px;}
.objectPhoto {width: 320px;}
.objectPhoto img {width: 100%; height: 100%; border: 1px solid transparent; object-fit: cover;}
.objectInfo{justify-content: space-between; align-items: baseline; width: 100%;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}

.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.objectPass {display: flex; justify-content: flex-start; flex-wrap: wrap;}
.objectPass  p:not(:first-child) {margin-left: 10px; padding-left: 5px;position: relative;}
.objectPass p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: -3px;
	top: 9px;
} 
.objectPass .blue-dot {margin-right: 7px; padding-right: 12px; position: relative;}
.objectPass .blue-dot:not(:last-child)::after {
	content: '';
	position: absolute;
	margin-left: 7px;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #01b0e0;
	top: 9px;
    right: 2px;
}
.objectPass-row {display: flex; flex-wrap: wrap;}
.objectPrice {text-align: end; padding-right: 0px;}
.objectPrice {display: flex; justify-content: space-between;}
.objectPrice span {flex: 1 1 0;
    max-width: 100%;
    height: 2px;
    margin: 9px 5px;
    border-bottom: 2px dotted #ccc;
}
.objectDev p:first-child {margin-right: 7px;}
.flats {padding-left: 5px;}
.gkTaskLink  {color: #9e77f3; font-weight: 300;}
.gkTaskLink:hover {color: #01b0e0; cursor: pointer;}

.callClass {border: 1px solid #01B0E0; border-radius: 6px; padding-top: 5px;}

@media (max-width: 1200px) {
	.objectContent {flex-direction: column;}
	.leftPart, .objectImg {margin: 0 auto 20px auto;}
	.rightPart {padding-left: 0;}
}
@media (max-width: 768px) {	
	.objectHeader h4 {margin-bottom: 10px;}
	.objectPhoto, .objectImg {width: 100%;}
	.objectImg {height: 220px;}
	.leftPart {padding-right: 0px;}
	.objectInfo {display: flex; flex-direction: column;}
	.objectBadges {text-align: start; display: flex; flex-direction: row; flex-wrap: wrap;}
	.flats {padding-right: 0px; padding-left: 15px;}
	.objectDev {display: flex; justify-content: space-between; padding-right: 0px;}
	.objectDev p:last-child {text-align: end;}
	.objectDev span {margin-left: 0px!important;}
	.objectDescr-title {display: none;}
}

</style>
